import { SVGProps } from 'react';

const Handbag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 11V6a4 4 0 0 1 8 0v5M2.048 18.566A2 2 0 0 0 4 21h16a2.002 2.002 0 0 0 1.952-2.434l-2-9A2 2 0 0 0 18 8H6a2 2 0 0 0-1.952 1.566z"
    />
  </svg>
);
export default Handbag;
